import { useState } from "react";

interface ConfirmDialogProps {
  title: string;
  description: string;
  confirmLabel: string;
  danger?: boolean;
  /** trueの場合、理由テキストの入力を必須にする（差し戻し用途）。 */
  requireReason?: boolean;
  onConfirm: (reason?: string) => void;
  onCancel: () => void;
  busy?: boolean;
  errorMessage?: string | null;
}

export function ConfirmDialog({
  title,
  description,
  confirmLabel,
  danger,
  requireReason,
  onConfirm,
  onCancel,
  busy,
  errorMessage,
}: ConfirmDialogProps) {
  const [reason, setReason] = useState("");
  const disabled = busy || (requireReason && !reason.trim());

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-box">
        <h3>{title}</h3>
        <p>{description}</p>
        {requireReason && (
          <textarea
            placeholder="差し戻し理由（必須）"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            autoFocus
          />
        )}
        {errorMessage && (
          <p style={{ color: "var(--danger)", fontSize: 12 }}>{errorMessage}</p>
        )}
        <div className="modal-actions">
          <button className="btn" onClick={onCancel} disabled={busy}>
            キャンセル
          </button>
          <button
            className={danger ? "btn btn-danger" : "btn btn-primary"}
            disabled={disabled}
            onClick={() => onConfirm(requireReason ? reason.trim() : undefined)}
          >
            {busy ? "処理中…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
